import { mixin as clickaway } from 'vue-clickaway'
import {ToggleButton} from "vue-js-toggle-button/src";
import InputButton from '../../components/input-button/InputButton'
import {CookieService} from "@/services/cookie.service";

export default {
    name: 'InputDropdownMenu',
    mixins: [ clickaway ],

    data() {
        return {
            dropdownClass: 'input-dropdown-hidden',
            error: '',
            selectedValue: ''
        }
    },
    components: {
        InputButton,
        ToggleButton
    },

    props: {
        label: String,
        required: Boolean,
        placeholder: String,
        value: [String, Number],
        data: Array,
        disabled: Boolean,
        extension: String
    },

    methods: {
        showItems() {
            this.dropdownClass = this.disabled ? 'input-dropdown-hidden' : ''
        },

        hideItems() {
            this.dropdownClass = 'input-dropdown-hidden'
        },

        selectItem(index) {
            this.selectedValue = this.data[index].value
            this.$emit('change', this.data[index].id)
            this.hideItems()
            this.checkForError()
        },

        checkForError() {
            this.error = (this.value != '' && this.value != undefined) || this.selectedValue != '' || !this.required ? '' : 'input-dropdown-error'
        },

        reset() {
            this.selectedValue = ''
        },

        clearCookies() {
            const confirmed = confirm("Do you want to clear all cookies?")
            if (confirmed ) {
                CookieService.clearCookie("preference")
                CookieService.clearCookie("page")
                window.location.reload()
            }
        }
    }
}
